// Money in different currencies is never added together: totals are kept
// per currency, SRD first and then the others alphabetically. A missing
// currency counts as `fallback`.
export function totalsByCurrency(items, amountOf, currencyOf, fallback = 'SRD') {
  const totals = new Map();
  for (const item of items || []) {
    const currency = currencyOf(item) || fallback;
    totals.set(currency, (totals.get(currency) || 0) + (parseFloat(amountOf(item)) || 0));
  }
  return [...totals]
    .map(([currency, amount]) => ({ currency, amount }))
    .sort((a, b) => (a.currency === 'SRD' ? -1 : b.currency === 'SRD' ? 1 : a.currency.localeCompare(b.currency)));
}
